import moment from 'moment';
import numeral from 'numeral';
import 'numeral/locales';
import h from 'virtual-dom/h';
import Inputmask from 'inputmask';
import ko from 'knockout';
import 'knockout.validation';
import flatpickr from 'flatpickr';
import { Dutch } from 'flatpickr/dist/l10n/nl.js';
import Choices from 'choices.js';

import { listviewDefaults, listviewColumnActionDefaults, listviewRenderTypeDefaults } from './listview';
import './custom-packages/knockout-file-bindings/knockout-file-bindings';
import './knockout.bindings';
import { customFetch as fetch } from './fetch';
import { log } from 'gulp-util';

declare global {
    interface Window {
        dataLayer: any;
    }
}

export const pushToDataLayer = (layer: number) => {
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
            'event': `step_${layer}`
        });
    }
};

moment.locale('nl-nl');
numeral.locale('nl-nl');
flatpickr.localize(Dutch);

listviewDefaults.tableProps = { className: 'table' };
listviewDefaults.noResults = () => 'Geen resultaten';
listviewColumnActionDefaults.popupProps = { className: 'popup popup--small' };
listviewColumnActionDefaults.confirmTitle = 'Bevestig';
listviewColumnActionDefaults.confirmButtonProps = { className: 'btn btn--green btn--normal' };
listviewColumnActionDefaults.cancelButtonProps = { className: 'btn btn--normal btn--white' };
listviewColumnActionDefaults.cancelHeaderButtonProps = { className: 'icon icon-normal icon-close-o' };
listviewColumnActionDefaults.confirmButtonContent = 'Bevestigen';
listviewColumnActionDefaults.cancelButtonContent = 'Annuleren';

listviewRenderTypeDefaults.datetime = (value: string, format: any) => {
    var date = moment(value);
    var formattedDate = date.format(format);
    return formattedDate;
};
listviewRenderTypeDefaults.number = (value: number, format: any) => {
    var num = numeral(value);
    var formattedNumeral = num.format(format);
    return formattedNumeral;
};
listviewRenderTypeDefaults.currency = (value: number, format: any) => {
    var num = numeral(value);
    format = `$${format}`;
    var formattedNumeral = num.format(format);
    return formattedNumeral;
};

[].forEach.call(document.getElementsByClassName('integer'), (element: any) => {
    Inputmask('integer', {
        rightAlign: false,
        autoGroup: true,
        groupSeparator: '.'
    }).mask(element);
});

[].forEach.call(document.getElementsByClassName('decimal'), (element: any) => {
    Inputmask('decimal', {
        rightAlign: false,
        autoGroup: true,
        digits: 2,
        radixPoint: ',',
        groupSeparator: '.'
    }).mask(element);
});

[].forEach.call(document.getElementsByClassName('date'), (element: any) => {
    Inputmask('dd-mm-yyyy', {
        placeholder: 'dd/mm/jjjj',
        clearMaskOnLostFocus: false
    }).mask(element);
});

[].forEach.call(document.getElementsByClassName('datetime'), (element: any) => {
    Inputmask('datetime', {
        placeholder: 'dd/mm/jjjj uu:mm',
        clearMaskOnLostFocus: false
    }).mask(element);
});

[].forEach.call(document.getElementsByClassName('time'), (element: any) => {
    Inputmask('hh:mm:ss', {
        placeholder: "uu:mm'ss",
        clearMaskOnLostFocus: false
    }).mask(element);
});

(<any>ko).fileBindings.defaultOptions.noFileText = 'Geen afbeelding gekozen';
(<any>ko).fileBindings.defaultOptions.buttonText = 'Kies afbeelding';
(<any>ko).fileBindings.defaultOptions.changeButtonText = 'Aanpassen';
(<any>ko).fileBindings.defaultOptions.clearButtonText = 'Wis';
(<any>ko).fileBindings.defaultOptions.buttonClass = 'btn btn--primary btn--normal';
(<any>ko).fileBindings.defaultOptions.clearButtonClass = 'btn btn--light btn--normal';

ko.validation.init({
    decorateInputElement: true,
    errorMessageClass: 'form_error',
    errorElementClass: 'isfalse'
});

ko.validation.insertValidationMessage = (element: Element) => {
    let span = document.createElement('span');
    span.className = ko.validation.utils.getConfigOptions(element).errorMessageClass || '';
    const parentGroup = element.closest('.input-group') || element;
    ko.validation.utils.insertAfter(parentGroup, span);

    return span;
};

const selBranch = <HTMLSelectElement>document.getElementById('selBranch');
if (selBranch) {
    selBranch.addEventListener('change', async () => {
        const selectedBranchId = selBranch.value;

        const fd = new FormData();
        fd.append('id', selectedBranchId);
        fd.append('url', window.location.toString());

        const response = await fetch('/Account/SwitchBranch', {
            method: 'POST',
            body: fd
        });

        let switchBranchError = false;

        console.log(response);

        response.errors?.forEach(e => {
            if (e.key === 'Error') {
                switchBranchError = true;
            }
        })

        if (switchBranchError) {
            window.location.href = '/Employer/Employees/Index'
        } else if (response.ok) {
            window.location.reload();
        }
    });
}

const html = document.documentElement;
const popups = <HTMLElement[]> Array.from(document.getElementsByClassName('popup'));
const popupToggles = <HTMLElement[]> Array.from(document.getElementsByClassName('popup_toggle'));
const popupCloses = <HTMLElement[]> Array.from(document.getElementsByClassName('popup_close'));
const backfaces = <HTMLElement[]> Array.from(document.getElementsByClassName('backface'));

popupToggles.forEach(element => {
    element.addEventListener('click', (e: Event) => {
        e.preventDefault();
        closePopups();

        let toggleId = element.dataset.toggle;
        if (toggleId) {
            if (toggleId.startsWith('#')) {
                toggleId = toggleId.substring(1);
            }

            const target = document.getElementById(toggleId);
            if (target) {
                html.classList.add('popup_open');
                target.classList.add('open');
                html.querySelector('.backface')!.classList.add('open');
            }
        }
    });
});

[...popupCloses, ...backfaces].forEach(element => {
    element.addEventListener('click', (e: Event) => {
        e.preventDefault();
        closePopups();
    });
});

export function closePopups() {
    html.classList.remove('popup_open');
    popups.forEach(popup => popup.classList.remove('open'));
    backfaces.forEach(backface => backface.classList.remove('open'));
}

export function openPopup(name: string) {
    const target = document.getElementById(name);

    if (target) {
        document.documentElement.classList.add('popup_open');
        target.classList.add('open');
        document.documentElement.querySelector('.backface')!.classList.add('open');
    }
}

html.classList.add('js-loaded');

(<any>window).dataLayer = (<any>window).dataLayer || [];
